//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    showPassword: false,
    showPasswordConfirmation: false,
    password: null,
    password_confirmation: null,
    hash: null,
  }),

  created() {
    this.hash = this.$route.params.hash
  },
  methods: {
    async submit() {
      await this.$store.dispatch("auth/password_reset", {
        password: this.password,
        password_confirmation: this.password_confirmation,
        hash: this.hash,
      })

      this.$router.push({ name: "login" })
    },
  },
}
